import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
    AnnualReportProvider,
    IEquityMovementScheduleData,
    IEquityMovementSchedulePeriodTable,
    ISectionData,
    PrintUsingPdfTronDto,
    RowTypes,
} from '@modeso/aumico-lib-annualreport-fe';
import { EditSectionTitleComponent, LANGUAGES } from '@modeso/aumico-lib-core-fe';
import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, map, tap } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'aumico-annualReport-equity-movement-schedule-swiss-print-preview-page',
    templateUrl: 'equity-swiss-print-preview.page.html',
    styleUrls: ['equity-swiss-print-preview.page.scss'],
})
export class EquityMovementScheduleSwissPrintPreviewPage implements OnInit {
    @Input() styleOptions: IStyleOptions | undefined;

    @Input() currentLanguage = LANGUAGES.SWISS_GERMAN;
    @Input() textColor: string;

    @Output() sectionTitleChanged: EventEmitter<string> = new EventEmitter<string>();

    tables: IEquityMovementSchedulePeriodTable[] = [];

    textAdditionAboveEmsTable: string | null = null;

    textAdditionBelowEmsTable: string | null = null;
    sectionTitle: string;


    constructor(
        private readonly annualReportProvider: AnnualReportProvider,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private dialog: MatDialog,
    ) {
        this.addSvgIcon('aumico-pattern-icon-edit-write');
    }

    ngOnInit(): void {
        this.annualReportProvider
            .getPrintView$()
            .pipe(
                filter((printViewData: PrintUsingPdfTronDto) => printViewData != null),
                filter((printViewData: PrintUsingPdfTronDto) => printViewData.data.ems != null),
                map((printViewData: PrintUsingPdfTronDto) => printViewData.data.ems),
                tap((emsSection: ISectionData) => (this.sectionTitle = emsSection.title)),
                map((emsSection: ISectionData) => {
                    return emsSection.data as IEquityMovementScheduleData;
                }),
                untilDestroyed(this),
            )
            .subscribe((emsData) => {
                this.tables = emsData.tables;

                this.textAdditionAboveEmsTable = emsData.textAdditionAboveEms;

                this.textAdditionBelowEmsTable = emsData.textAdditionBelowEms;
            });
    }

    columnNamesOf(table: IEquityMovementSchedulePeriodTable): string[] {
        const columnNamesRow = table.rows.find((row) => row.rowType === RowTypes.TABLE_HEAD);
        if (columnNamesRow == null) {
            return [];
        }
        return Object.keys(columnNamesRow)
            .filter((key) => key.includes('col'))
            .map((key) => columnNamesRow[key] as string);
    }

    public editSectionTitle(): void {
        const dialogRef = this.dialog.open<EditSectionTitleComponent, string, string | undefined>(
            EditSectionTitleComponent,
            {
                disableClose: false,
                panelClass: 'custom-modalbox',
                data: this.sectionTitle,
            },
        );

        dialogRef
            .afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
                if (result != null) {
                    this.sectionTitle = result;
                    this.sectionTitleChanged.emit(result);
                }
            });
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
}
